import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=bcc8ec6a&"
import script from "./Work.vue?vue&type=script&lang=js&"
export * from "./Work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/3aece8dd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bcc8ec6a', component.options)
    } else {
      api.reload('bcc8ec6a', component.options)
    }
    module.hot.accept("./Work.vue?vue&type=template&id=bcc8ec6a&", function () {
      api.rerender('bcc8ec6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Work.vue"
export default component.exports